import { React, useState } from "react";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import ModalNota from "./ModalNota";

const styles = {
  bgColor: "#EFF5F7 !important",
  text: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "21px",
    color: "#737373",
  },
  title: {
    fontFamily: "Nunito",
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "21px",
    color: "#1E729F",
  },
};
export default function NotaCard({
  title = "",
  description = "",
  data = "",
  co_id,
  nu_status,
  notas,
  setNotas,
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const maxCaracteres = 250;

  return (
    <Box
      bgcolor={styles.bgColor}
      sx={{
        borderRadius: "8px",
        boxSizing: "border-box",
        padding: "16px",
        height: "100%",
      }}
    >
      <Box
        onClick={handleOpen}
        sx={{
          "&:hover": { cursor: "pointer" },
          height: "100%",
        }}
        bgcolor={styles.bgColor}
      >
        <Stack
          direction={"column"}
          spacing={1}
          justifyContent={"space-between"}
          alignContent={"space-between"}
          bgcolor={styles.bgColor}
          height={"100%"}
        >
          <Box>
            <Box
              component="div"
              display={"flex"}
              justifyContent={"space-between"}
              flexDirection={"row"}
              bgcolor={styles.bgColor}
              sx={{
                paddingBottom: "5px",
              }}
            >
              <Typography style={styles.title}>{title}</Typography>
              <Typography style={styles.text}>Data: {data}</Typography>
            </Box>
            <Divider />

            <Typography
              style={styles.text}
              component="p"
              bgcolor={styles.bgColor}
              p={"5px 0px"}
            >
              {description}
            </Typography>
          </Box>
          <Typography
            style={{ ...styles.text, color: "#CCCCCC" }}
            component="span"
            bgcolor={styles.bgColor}
          >
            {description.length}/{maxCaracteres}
          </Typography>
        </Stack>
      </Box>
      <ModalNota
        openModal={open}
        setOpenModal={handleClose}
        edit={true}
        dados={{ title, description, data }}
        co_id={co_id}
        nu_status={nu_status}
        notas={notas}
        setNotas={setNotas}
      ></ModalNota>
    </Box>
  );
}
